import { SelectOption } from "../../Components/common/types";
import { StylesConfig } from "react-select";
import { DefaultTheme } from "styled-components";

//select options used in Contact component form
export const options: SelectOption[] = [
  { value: "design", label: "Design" },
  { value: "web-development", label: "Web Development" },
  { value: "mobile-development", label: "Mobile Development" },
];

//project options
export const projectOptions: SelectOption[] = [
  { value: "design", label: "Design" },
  { value: "web", label: "Web" },
  { value: "mobile", label: "Mobile" },
];

//project link options
export const projectLinkOptions: SelectOption[] = [
  { value: "liveDemo", label: "Live Demo" },
  { value: "github", label: "Github" },
];

//filter options used in workComponent and filterOptions
export const filterOptions: SelectOption[] = [
  { value: "all", label: "All" },
  { value: "design", label: "Design" },
  { value: "web", label: "Web" },
  { value: "mobile", label: "Mobile" },
];

const commonStyles = <T extends boolean> (
  styledComponentTheme: DefaultTheme,
  errorColor?: boolean,
  additionalStyles?: Partial<StylesConfig<SelectOption, T>>
): StylesConfig<SelectOption, T> => ({
  //outer container of the select input.
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? styledComponentTheme.text
      : "transparent",
    padding: "7px",
    borderRadius: "2px",
    borderWidth: "2px",
    borderColor: errorColor
      ? "red" // Apply red when there's an error
      : styledComponentTheme.text,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: styledComponentTheme.text,
    },
    ...((additionalStyles?.control && additionalStyles.control(provided, state)) || {}),
  }),

  // each option in the dropdown.
  option: (provided, state) => ({
    ...provided,
    borderRadius: "2px",
    backgroundColor: state.isSelected
      ? styledComponentTheme.circularIconTextBg
      : "transparent",
    color: state.isSelected
      ? styledComponentTheme.text
      : styledComponentTheme.circularIconTextBg,
    margin: "5px 0",
    fontSize: "12PX",
    "&:hover": {
      backgroundColor: styledComponentTheme.circularIconTextBg,
      color: styledComponentTheme.text,
    },
    ...(additionalStyles?.option?.(provided, state) || {}),
  }),

  //the placeholder text.
  placeholder: (provided, state) => ({
    ...provided,
    color: "grey",
    fontSize: "12px",
    ...(additionalStyles?.placeholder?.(provided, state) || {}),
  }),

  //dropdown menu.
  menu: (provided, state) => ({
    ...provided,
    padding: "5px 9px",
    borderRadius: "2px",
    backgroundColor: styledComponentTheme.text,
    ...(additionalStyles?.menu?.(provided, state) || {}),
  }),

  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure dropdown appears above other elements
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "white" : "grey",
    margin: "0 5px",
    background: state.isFocused
      ? "linear-gradient( #FF00D6, #FF4D00)"
      : "transparent",
    borderRadius: "50%",
    "&:hover": {
      background: "linear-gradient( #FF00D6, #FF4D00)",
      borderRadius: "50%",
      color: "white",
      margin: "0 5px",
    },
    ...(additionalStyles?.dropdownIndicator?.(provided, state) || {}),
  }),

  clearIndicator: (provided, state) => ({
    ...provided,
    color: "grey",
    margin: "0 5px",
    "&:hover": {
      color: "white",
      background: "linear-gradient( #FF00D6, #FF4D00)",
      margin: "0 5px",
      borderRadius: "50%",
    },
    ...(additionalStyles?.clearIndicator?.(provided, state) || {}),
  }),
});

export const getCustomStylesMultiSelect = (
  styledComponentTheme: DefaultTheme,
  errorColor?: boolean,
  additionalStyles?: Partial<StylesConfig<SelectOption, true>>
): StylesConfig<SelectOption, true> => {
  return {
    ...commonStyles(styledComponentTheme, errorColor, additionalStyles),

    // Multi-select value container
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: styledComponentTheme.selectedOption,
      ...(additionalStyles?.multiValue?.(provided, state) || {}),
      // color: 'red',//not working
    }),

    // Multi-select value label
    multiValueLabel: (provided) => ({
      ...provided,
      color: styledComponentTheme.circularIconTextBg,
    }),

    // Multi-select value remove button
    multiValueRemove: (provided, state) => ({
      ...provided,
      color: styledComponentTheme.circularIconTextBg,
      "&:hover": {
        color: "white",
        background: "linear-gradient( #FF00D6, #FF4D00)",
      },
      ...(additionalStyles?.multiValueLabel?.(provided, state) || {}),
    }),
  };
};

export const getCustomStylesSingleSelect = (
  styledComponentTheme: DefaultTheme,
  errorColor?: boolean,
  additionalStyles?: Partial<StylesConfig<SelectOption, false>>
): StylesConfig<SelectOption, false> => {
  return {
    ...commonStyles(styledComponentTheme, errorColor, additionalStyles),
    //the selected value
    singleValue: (provided, state) => ({
      ...provided,
      padding: "3px 15px",
      borderRadius: "2px",
      backgroundColor: styledComponentTheme.selectedOption,
      color: styledComponentTheme.circularIconTextBg,
      ...(additionalStyles?.singleValue?.(provided, state) || {}),
    }),
  };
};
